import React, { useEffect } from 'react';
import TemplateData, { isMobileHeaderExp } from '../utility/getTemplateData';
import { Row, Col } from '@paypalcorp/pp-react';
import ConfirmationMyAccount from './ConfirmationMyAccount';
import ConfirmationSocialShare from './ConfirmationSocialShare';
import ConfirmationTransactionId from './ConfirmationTransactionId';
import OfferConfirmation from '../components/offerConfirmation';
import PropTypes from 'prop-types';
import SignUpAlert from '../components/guest/SignUpAlert';
import VoucherFlowDisclaimer from '../components/voucherFlowDisclaimer';
import ConfirmationRedirect from './ConfirmationRedirect';
import { endCustomCPLTrackingForConfirmationPage } from '../utility/cpl';

function ConfirmationView(props) {
  const {
    accountLink,
    accountMessage,
    autoRedirect,
    autoRedirectUrl,
    autoRedirectMethod,
    engamentText,
    footer,
    handleRedirect,
    hostedButtonId,
    illustration,
    isSignUp,
    isVoucherFlow,
    message,
    messages,
    offerProgram,
    orgName,
    postBackData,
    returnTo,
    returnText,
    signUpProps,
    showMyAccount,
    syncReturnUrl,
    txnId,
  } = props;

  useEffect(() => {
    endCustomCPLTrackingForConfirmationPage();
  }, []);

  function showSocialShare() {
    if (TemplateData.socialSharePreference && hostedButtonId) {
      return (
        <ConfirmationSocialShare
          hostedButtonId={hostedButtonId}
          orgName={orgName}
          messages={messages}
        />
      );
    }
    return null;
  }

  return (
    <div>
      {isSignUp && <SignUpAlert {...signUpProps} />}
      <div
        className={`donate_wrapper confirmation ${
          isMobileHeaderExp() ? 'mobile_view' : ''
        }`}
      >
        <Row>
          <Col xs={12}>{illustration}</Col>
        </Row>

        {message}

        {isVoucherFlow && (
          <OfferConfirmation offerProgram={offerProgram} txnId={txnId} />
        )}

        {autoRedirect && autoRedirectUrl && (
          <ConfirmationRedirect
            autoRedirectMethod={autoRedirectMethod}
            autoRedirectUrl={autoRedirectUrl}
            handleRedirect={handleRedirect}
            orgName={orgName}
            postBackData={postBackData}
            returnText={returnText}
            returnTo={returnTo}
            syncReturnUrl={syncReturnUrl}
          />
        )}

        {isVoucherFlow && <VoucherFlowDisclaimer />}

        <ConfirmationTransactionId transactionId={txnId} />

        {showMyAccount && (
          <ConfirmationMyAccount
            engamentText={engamentText}
            message={accountMessage}
            link={accountLink}
          />
        )}
      </div>
      {showSocialShare()}
      {footer}
    </div>
  );
}

ConfirmationView.propTypes = {
  accountLink: PropTypes.string,
  accountMessage: PropTypes.string,
  autoRedirectMethod: PropTypes.string,
  autoRedirect: PropTypes.bool,
  autoRedirectUrl: PropTypes.string,
  engamentText: PropTypes.string,
  footer: PropTypes.object,
  handleRedirect: PropTypes.func,
  hostedButtonId: PropTypes.string,
  isVoucherFlow: PropTypes.bool,
  illustration: PropTypes.object,
  isSignUp: PropTypes.bool,
  message: PropTypes.object,
  messages: PropTypes.object,
  offerProgram: PropTypes.object,
  orgName: PropTypes.string,
  postBackData: PropTypes.object,
  redirect: PropTypes.func,
  returnTo: PropTypes.string,
  returnText: PropTypes.string,
  showMyAccount: PropTypes.bool,
  signUpProps: PropTypes.object,
  syncReturnUrl: PropTypes.string,
  txnId: PropTypes.string,
};

export default ConfirmationView;
